import React from "react"

type Props = {
    className?          : string

    label               : string
    icon?               : string
    infoMessage         : string

    disabled?           : boolean

    onClick             : func
    onSetInfoMessage    : func
}

export default function MenuItem(props: Props) {

    const onMouseEnter = () => {if (props.onSetInfoMessage) props.onSetInfoMessage(props.infoMessage)}
    const onMouseLeave = () => {if (props.onSetInfoMessage) props.onSetInfoMessage(null)}

    const classes = Classes("option", "with-icon", props.className, {
        disabled: props.disabled
    })

    return (
        <div className      = {classes}
             onClick        = {!props.disabled ? props.onClick : undefined}
             onMouseEnter   = {onMouseEnter}
             onMouseLeave   = {onMouseLeave}>
            <div className={Classes("ico", props.icon)}/>
            <div className="label">{props.label}</div>
        </div>
    )
}